//
 const BASE_URL = 'https://www.bywhjt.com/'
//
export default {
    BASE_URL
}